import {
  BasketColumn,
  BasketColumnKeys,
  Total,
} from 'graphql-api/baskets-api-interfaces';

const isPriceColumn = (column: BasketColumn) =>
  [
    BasketColumnKeys.Wsp,
    BasketColumnKeys.Rrp,
    BasketColumnKeys.Net,
    BasketColumnKeys.Value,
    BasketColumnKeys.ValueRrp,
    BasketColumnKeys.ValueNet,
    BasketColumnKeys.Discount,
    BasketColumnKeys.DiscountRrp,
    BasketColumnKeys.SimulatedTotal,
    BasketColumnKeys.Total,
    BasketColumnKeys.Gross,
  ].includes(column.key);

const isRrpColumn = (column: BasketColumn) =>
  [
    BasketColumnKeys.Rrp,
    BasketColumnKeys.ValueRrp,
    BasketColumnKeys.DiscountRrp,
  ].includes(column.key);

export const addCurrencyToPriceColumns = (
  columns: BasketColumn[],
  total: Total,
): BasketColumn[] => {
  return columns.map((column) => ({
    ...column,
    currency: isPriceColumn(column)
      ? isRrpColumn(column)
        ? total?.requested?.currencyRrp
        : total?.requested?.currency
      : undefined,
  }));
};
